import { render, staticRenderFns } from "./ChangeChannelTypeSidebarContent.vue?vue&type=template&id=67638232&scoped=true"
import script from "./ChangeChannelTypeSidebarContent.vue?vue&type=script&lang=js"
export * from "./ChangeChannelTypeSidebarContent.vue?vue&type=script&lang=js"
import style0 from "./ChangeChannelTypeSidebarContent.vue?vue&type=style&index=0&id=67638232&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67638232",
  null
  
)

export default component.exports